import DualPaneContainer from './src/main'

DualPaneContainer.install = function (Vue) {
  Vue.component(DualPaneContainer.name, DualPaneContainer)
}

export default DualPaneContainer
